// Need to use the React-specific entry point to import createApi
import {
  DashboardRoutesCounts,
  NotificationProps,
  Response,
  RouteWithStopsAndDriver,
} from "Data/interfaces";
import { getCurrentDate } from "Helper";
import { baseApi } from "./baseApi";

// Define a service using a base URL and expected endpoints
export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRoutesCounts: builder.query<Response<DashboardRoutesCounts>, void>({
      query: () => {
        return {
          url: `get-route-counts?date=${getCurrentDate()}`,
          method: "Get",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getDashboardRoute: builder.query<Response<RouteWithStopsAndDriver[]>, void>(
      {
        query: () => {
          return {
            url: `get-dashboard-routes?date=${getCurrentDate()}`,
            method: "Get",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
          };
        },
      }
    ),
    getDashboardRouteDetail: builder.query<
      Response<RouteWithStopsAndDriver>,
      string | unknown
    >({
      query: ({ id }) => {
        return {
          url: `get-route-details/${id}`,
          method: "Get",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getNotification: builder.query<Response<NotificationProps[]>, void>({
      query: () => {
        return {
          url: `notifications`,
          method: "Get",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetRoutesCountsQuery,
  useLazyGetDashboardRouteQuery,
  useGetDashboardRouteDetailQuery,
  useLazyGetDashboardRouteDetailQuery,
  useLazyGetNotificationQuery,
} = dashboardApi;
